import { logInIntercomUser, updateIntercomUser } from '@arnold/common';
import { CHAT_OVERVIEW_LOGIN_REQUIRED_FOR_MANAGERS_ERROR_MESSAGE } from '@arnold/core';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router';
import { CenterView, ErrorMessage, FullScreenWindow, Loading } from '../components';
import { useChannelOverviewQuery } from '../generated/hooks';
import Overview from './Overview';

type IProps = {
  setSomeReport: (someReport: boolean) => void;
};
const ChatOverview = ({ setSomeReport }: IProps) => {
  const { t, i18n } = useTranslation('error');
  const params = useParams<{ id: string }>();
  const history = useHistory();

  const { data, loading, error } = useChannelOverviewQuery({
    variables: {
      channelSlug: params.id,
      languageCode: i18n.language,
    },
    fetchPolicy: 'network-only',
    onCompleted(data) {
      const user = data.channelOverview.user;
      if (user) {
        logInIntercomUser(user.id, user.intercomHash);
        updateIntercomUser({
          user_id: user.id,
          user_hash: user.intercomHash,
          name: `${user.firstname} ${user.surname}`,
          email: user.username,
        });
      }
    },
  });

  useEffect(() => {
    setSomeReport(!!data?.channelOverview.respondents?.some((respondent) => (respondent.reports?.length || 0) > 0));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(data?.channelOverview.respondents), setSomeReport]);
  if (
    (data?.channelOverview && !data.channelOverview.respondents) ||
    error?.message === CHAT_OVERVIEW_LOGIN_REQUIRED_FOR_MANAGERS_ERROR_MESSAGE
  ) {
    // if auth using slug fails we redirect to overview which uses cookies for auth
    // then if cookie auth fails, the overview will redirect to the login page
    history.replace('/overview/answers');
    return <></>;
  }

  if (error) {
    return (
      <FullScreenWindow>
        <CenterView>
          <ErrorMessage>{t('default')}</ErrorMessage>
        </CenterView>
      </FullScreenWindow>
    );
  }
  if (loading || !data?.channelOverview.respondents || !data?.channelOverview.user) {
    return <Loading />;
  }

  return (
    <Overview
      respondents={data?.channelOverview.respondents}
      baseUrl={`/chat-overview/${params.id}`}
      user={data?.channelOverview.user}
      auth={{
        channelSlug: params.id,
      }}
    />
  );
};

export default ChatOverview;
